import type { Node } from 'slate';

import { Element } from 'slate';

export const type = 'recipe';
export const rdmdType = 'tutorial-tile';
export const isRecipe = (node: Node) => Element.isElementType(node, type);
